import { useEffect } from "react";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { logError } from "infra/packages/@sentry/logError";
import colors from "core/resources/theme/colors";

export function showSuccess(
  message = "Operação realizada com sucesso",
  title = "Sucesso"
) {
  return Swal.fire(title, message, "success");
}

export function showError(
  message = "Houve um problema ao realizar esta operação",
  title = "Erro"
) {
  return Swal.fire(title, message, "error");
}

export function showErrorAxios(
  error: any,
  fallbackMessage?: string,
  action?: () => void
) {
  let message: any = undefined;

  if (!error) {
    return message ?? fallbackMessage;
  }

  if (
    Number(error.response?.status) >= 400 &&
    Number(error.response?.status) <= 499
  ) {
    if (typeof error.response?.data?.message === "string") {
      message = error.response.data.message;
    } else if (
      Array.isArray(error.response?.data?.message) &&
      error.response.data.message.length
    ) {
      message = error.response.data.message[0];

      const matches = message.match(/([A-Za-z0-9_-]*\.)(\d)(\.)(.*)/);

      if (matches?.length) {
        message = `${matches[4]} ${Number(matches[2]) + 1}`;
      }
    }
  } else if (Number(error.response?.status) >= 500) {
    message = "Está havendo uma inconsistência no sistema no momento.";
  } else if (
    error.message === "Network Error" ||
    error.name === "Network Error"
  ) {
    logError(error);
    message =
      "Houve um problema ao se conectar com o servidor. Verifique sua conexão e tente novamente.";
  }

  if (action) {
    message = `${message ?? fallbackMessage}\n\nDeseja continuar?`;
    setTimeout(async () => {
      const { isConfirmed } = await showConfirm(message);

      if (isConfirmed) {
        action();
      }
    }, 150);
  } else {
    setTimeout(() => {
      showError(message ?? fallbackMessage);
    }, 150);
  }

  return;
}

export function showConfirm(
  message = "Deseja realmente realizar esta operação?",
  config: SweetAlertOptions<any, any> = {}
) {
  const instance = Swal.fire({
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    title: "Aviso",
    icon: "info",
    text: message,
    confirmButtonColor: colors.primary,
    ...config,
  });

  return instance;
}

export function showConfirm2(config: {
  message?: string;
  onOk?: () => void;
  onCancel?: () => void;
}) {
  config.message = config.message || "Deseja realmente realizar esta operação?";

  const instance = Swal.fire({
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    title: "Aviso",
    icon: "info",
    text: config.message ?? "Deseja realmente realizar esta operação?",
    confirmButtonColor: colors.primary,
    ...config,
  });

  instance.then(({ isConfirmed }) => {
    if (isConfirmed && config.onOk) {
      setTimeout(() => {
        config.onOk!();
      }, 250);
    } else if (!isConfirmed && config.onCancel) {
      config.onCancel();
    }
  });

  return instance;
}

export function showLoading() {
  Swal.showLoading();
}

export function hideLoading() {
  Swal.close();
}

export function useLoading(bool: boolean) {
  useEffect(() => {
    if (bool) {
      showLoading();
    } else {
      hideLoading();
    }

    return () => hideLoading();
  }, [bool]);
}
